export default __webpack_public_path__ + "static/media/googleplay-badge.21530085.svg";